import React from 'react';
import { approvedAmountTypes, LoanStatusType } from '@apply/constants';
import { Column } from 'devextreme-react/data-grid';

interface LoanCommitOrApprovalColumnParameters {
    statusId: LoanStatusType;
}

export const LoanCommitOrApprovalColumn: React.FC<LoanCommitOrApprovalColumnParameters> = ({ statusId }) => {
    if (approvedAmountTypes.includes(statusId)) {
        return [
            <Column
                key='committed'
                dataField='commitment'
                caption='Approved Amt'
                dataType='number'
                format='currency'
                width={110}
                alignment={'left'}
            />,
        ];
    } else {
        return [
            <Column
                key='promissoryNote'
                dataField='promissoryNote'
                caption='Committed'
                dataType='number'
                format='currency'
                width={90}
                alignment={'left'}
            />,
        ];
    }
};
